import api from './api';

export const orderService = {
  // Get all orders with pagination and search
  async getOrders(params = {}) {
    const response = await api.get('/orders', { params });
    return response.data;
  },

  // Get a specific order by ID
  async getOrder(id) {
    const response = await api.get(`/orders/${id}`);
    return response.data.data;
  },

  // Create a new order from a quote
  async createOrder(quoteEntryId) {
    const response = await api.post('/orders', { quoteEntryId });
    return response.data.data;
  },

  // Update an order
  async updateOrder(id, orderData) {
    const response = await api.put(`/orders/${id}`, orderData);
    return response.data.data;
  },

  // Delete an order
  async deleteOrder(id) {
    const response = await api.delete(`/orders/${id}`);
    return response.data.data;
  },

  // Get orders for a specific customer
  async getCustomerOrders(customerId) {
    const response = await api.get('/orders', { params: { customerId } });
    return response.data;
  },
};